import { useWizard } from 'components/wizard/WizardContext';
import React from 'react'
import styles from "../styles.module.scss"

const VendorType = () => {
    const { values } = useWizard();
    const { vendorType } = values;

    return (
        <div className={styles['vendorTypeWrapper']}>
            <div className={styles['vendorTypeLabel']}>Vendor Type:</div>
            <div className={styles['vendorType']}>{vendorType ?? 'NA'}</div>
        </div>
    )
}

export default VendorType;